import type { SVGProps } from 'react';
const SvgSelectorArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="var(--color-primary)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.188 9.731 12 6.26 8.812 9.73M15.188 14.269 12 17.74 8.812 14.27"
    />
  </svg>
);
export default SvgSelectorArrow;
